(() => {
  if (window.evilkoSharedNavigationReady) return;
  window.evilkoSharedNavigationReady = true;

  const mobileQuery = window.matchMedia('(max-width: 1099px)');
  const openGames = () => document.querySelectorAll('[data-en-games-nav][open]');
  const openMobileMenus = () => document.querySelectorAll('[data-en-mobile-menu][open]');
  const syncMobileMenu = menu => {
    const toggle = menu.querySelector(':scope > summary');
    if (!toggle) return;
    toggle.setAttribute('aria-expanded', String(menu.open));
    toggle.setAttribute('aria-label', menu.open ? toggle.dataset.closeLabel : toggle.dataset.menuLabel);
  };
  const closeGames = (disclosure, restoreFocus = false) => {
    disclosure.open = false;
    if (restoreFocus) disclosure.querySelector('summary')?.focus();
  };
  const closeMobileMenu = (menu, restoreFocus = false) => {
    menu.open = false;
    menu.querySelectorAll('[data-en-games-nav][open]').forEach(disclosure => closeGames(disclosure));
    syncMobileMenu(menu);
    if (restoreFocus) menu.querySelector(':scope > summary')?.focus();
  };
  const initializeMenus = () => document.querySelectorAll('[data-en-mobile-menu]').forEach(syncMobileMenu);

  document.addEventListener('toggle', event => {
    const menu = event.target;
    if (!(menu instanceof HTMLElement) || !menu.matches('[data-en-mobile-menu]')) return;
    syncMobileMenu(menu);
    if (menu.open) openMobileMenus().forEach(other => {
      if (other !== menu) closeMobileMenu(other);
    });
  }, true);

  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    openGames().forEach(disclosure => {
      if (!disclosure.contains(event.target) || event.target.closest('a')) closeGames(disclosure);
    });
    openMobileMenus().forEach(menu => {
      if (!menu.contains(event.target) || event.target.closest('a')) closeMobileMenu(menu);
    });
  });

  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const focusedGames = [...openGames()].find(disclosure => disclosure.contains(document.activeElement));
    if (focusedGames) {
      closeGames(focusedGames, true);
      event.preventDefault();
      return;
    }
    openGames().forEach(disclosure => closeGames(disclosure));
    openMobileMenus().forEach(menu => {
      closeMobileMenu(menu, menu.contains(document.activeElement));
      event.preventDefault();
    });
  });

  document.addEventListener('focusin', event => {
    openGames().forEach(disclosure => {
      if (!disclosure.contains(event.target)) closeGames(disclosure);
    });
    openMobileMenus().forEach(menu => {
      if (!menu.contains(event.target)) closeMobileMenu(menu);
    });
  });

  mobileQuery.addEventListener('change', event => {
    if (!event.matches) openMobileMenus().forEach(menu => {
      const hadFocus = menu.contains(document.activeElement);
      closeMobileMenu(menu);
      if (hadFocus) menu.closest('.en-site-header')?.querySelector('.en-logo')?.focus();
    });
  });
  document.addEventListener('shopify:section:load', initializeMenus);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeMenus, { once: true });
  else initializeMenus();
})();
